import { useAppSelector } from '../store/store';

// Preços do produto, lidos da config dinâmica (asaas_plan_config via subscription.plan).
// Fonte única pra landing, checkouts, upsells e FAQ — mudar no painel reflete em tudo.
// Os fallbacks só valem enquanto a config carrega (ou se a leitura falhar).
//
// ⚠️ ELES ERAM OS PREÇOS DO MODELO ANTIGO. Enquanto a config não chegava, a landing anunciava
// R$ 39,90 e R$ 335,16 — valores que deixaram de existir com a assinatura única. Um fallback
// desatualizado é pior do que nenhum: ele não falha, só mente durante o carregamento, e o número
// errado aparece exatamente para quem abre a página pela primeira vez.
const FALLBACK_MONTHLY = 57.9; // assinatura PRO mensal
const FALLBACK_ANNUAL = 463.2; // assinatura PRO anual
const FALLBACK_PERFIL = 27.9; // cada perfil de artista além do incluso, por mês
const FALLBACK_GB = 7.9; // cada GB além dos 30 inclusos, por mês
// O pagamento único por perfil saiu da web. O valor continua aqui porque o app nativo ainda o
// exibe enquanto a release nova não sai; nada na web deve ler `once`.
const FALLBACK_ONCE = 199.9;

export const fmtBRL = (n: number) => n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

export const usePlanPrices = () => {
  const plan = useAppSelector((s) => s.subscription.plan);
  const once = plan?.profileUnlockValue ?? FALLBACK_ONCE;
  const monthly = plan?.monthlyValue ?? FALLBACK_MONTHLY;
  const annual = plan?.annualValue ?? FALLBACK_ANNUAL;
  // Os add-ons da assinatura. Eles já eram cobrados pelo checkout e não tinham por onde ser
  // ANUNCIADOS: a landing falava de perfis e de espaço sem nunca dizer o preço de nenhum dos dois.
  const perfilExtra = plan?.profileAddonValue ?? FALLBACK_PERFIL;
  const gbExtra = plan?.storageAddonValuePerGb ?? FALLBACK_GB;
  const discountPct = monthly > 0 ? Math.round((1 - annual / (monthly * 12)) * 100) : 0;
  // O anual pode sair da venda (`annual_enabled`, como em 05/10/2026: "deixar somente o mensal").
  // Sem a config carregada, ele não aparece: anunciar um plano que não se vende é pior do que
  // mostrá-lo um instante depois.
  const annualEnabled = !!(plan?.annualEnabled && plan?.annualValue && plan.annualValue > 0);
  return {
    annualEnabled,
    once,
    monthly,
    annual,
    perfilExtra,
    gbExtra,
    discountPct,
    onceFmt: fmtBRL(once),
    monthlyFmt: fmtBRL(monthly),
    annualFmt: fmtBRL(annual),
    perfilExtraFmt: fmtBRL(perfilExtra),
    gbExtraFmt: fmtBRL(gbExtra),
  };
};
